import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

const JobPickupLocation = ({ text, data }) => (
  <div style={{
      position: 'relative', color: 'white', background: 'green', textAlign: 'center',
      height: 15, width: 15, borderRadius: '0', content: "P", lineHeight: "15px"
    }}
    className="P"
    >
    P
  </div>
);
const JobDropoffLocation = ({ text, data }) => (
  <div style={{
      position: 'relative', color: 'white', background: 'red', textAlign: 'center',
      height: 15, width: 15, borderRadius: '0', content: "D", lineHeight: "15px"
    }}
    className="D"
    >
    D
  </div>
);
const GeoLocation = ({text, data}) => (
  <div style={{
      position: 'relative', color: 'white', background: 'blue', textAlign: 'center',
      height: 2, width: 2, borderRadius: '0', content: "", lineHeight: "0"
    }}
    onClick={() => {
      'driver was here @ [this time]';
    }}
    className="D"
    >
  </div>
);

export default class SingleJobMapWithGeolocations extends Component {
  static googleMap;
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      jobId: props.jobId,
      visible: false,
      center: {lat: 53.0236, lng: -2.211},
      zoom: 7,
      geoLocations: [],
      pickupAddress: props.pickupAddress || [],
      dropoffAddress: props.dropoffAddress || [],
      url: props.url || "/api/v1/portal/geolocations/job/"+props.data.jobId,
      bootstrapURLKeys: { key: process.env.MIX_GOOGLE_API_KEY },
      showMap: false
    };
  }
  async getGeolocations() {
    try {
      let url = this.state.url;
      const response = await fetch(url, {
        method: "GET",          
        mode: "cors",          
        cache: "no-cache",    
        credentials: "same-origin",
        headers: {            
          "Authorization": `Bearer ${window.api_token}`,  
          "Accept": "application/json"
        }
      });
  
      const geoLocationsJson = await response.json();
      this.setState({
        geoLocations: geoLocationsJson,  
        isLoading: false                 
      });
    } catch (error) {
      console.error("Error fetching geolocations:", error);
      this.setState({ isLoading: false });
    }
  }
  handleMarkerClick = (id) => {
    this.setState({ selectedLocationId: id });
  };

  handleClosePopup = () => {
    this.setState({ selectedLocationId: null });
  };

  handleShowMap = () => {
    this.setState({ showMap: true }, () => {
      this.getGeolocations();
    });
  };
  render() {
    const { geoLocations, selectedLocationId, showMap } = this.state;
    return (
      <div id="g4-logistics-portal-jobs-table-job-full-details-map-container">
        {showMap ? (
          <GoogleMapReact
            bootstrapURLKeys={this.state.bootstrapURLKeys}
            defaultCenter={this.state.center}
            defaultZoom={this.state.zoom}
            resetBoundsOnResize
          >
            {geoLocations.map((location) => (
              <GeoLocation
                key={`geolocation-${location.id}`}
                data={location}
                lat={location.latt}
                lng={location.long}
                isSelected={selectedLocationId === location.id}
                onClick={() => this.handleMarkerClick(location.id)}
                onClose={this.handleClosePopup}
              />
            ))}
            <JobDropoffLocation
              data={this.props.data.dropoffAddress}
              key={"dropoff-" + this.props.data.dropoffAddress.id}
              lat={this.props.data.dropoffAddress.latt}
              lng={this.props.data.dropoffAddress.long}
            />
            <JobPickupLocation
              data={this.props.data.pickupAddress}
              key={"pickup-" + this.props.data.pickupAddress.id}
              lat={this.props.data.pickupAddress.latt}
              lng={this.props.data.pickupAddress.long}
            />
          </GoogleMapReact>
        ) : (
          <>
            <img
              src="/images/job/logistics-portal.png"
              alt="map placeholder"
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: 0.4,
                top: 0,
                left: 0
              }}
            />
            <button
              onClick={this.handleShowMap}
              id="load-map"
              className='btn btn-lg btn-primary'
            >
              Click here for the latest mapping details
            </button>
          </>
        )}
      </div>
    );
  }
}
